import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { Color, Tile, TILE_TOKEN, TileId, TileType, TRANSLATION_NS } from '@contact/upgrade';

@NgModule({})
export class WallboardConfForRootModuleModule {
  constructor(@Optional() @SkipSelf() parentModule: WallboardConfForRootModuleModule) {
    if (parentModule) throw new Error(`[WallboardConfForRootModuleModule] module is already loaded`);
  }
  static instance(options: { path: string }): ModuleWithProviders<WallboardConfForRootModuleModule> {
    return {
      ngModule: WallboardConfForRootModuleModule,
      providers: [
        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.WALLBOARD_CONFIG,
            type: TileType.STANDARD,
            icon: 'tile_wallboard_settings',
            color: Color.GREEN,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
            activePlatform: 'desktop',
          } as Tile,
          multi: true,
        },
        {
          provide: TRANSLATION_NS,
          useValue: 'wallboard',
          multi: true,
        },
      ],
    };
  }
}
